import React, {
  createContext,
  useState,
  useRef,
  Dispatch,
  useEffect,
} from "react";
import { ModuleInfoImage, ModuleInfo } from "../../../Types";

interface ModuleProviderProps {
  children: JSX.Element;
}

interface ModuleContextTypes {
  moduleInfo: ModuleInfo | null;
  prevModuleInfo: ModuleInfo | null;
  setModuleInfo: (moduleInfo: ModuleInfo) => void;
  moduleImages: ModuleInfoImage[] | null;
  setModuleImages: Dispatch<ModuleInfoImage[]>;
  areGridLinesEnabled: boolean;
  setAreGridLinesEnabled: Dispatch<boolean>;
  isFilteredImage: boolean;
  setIsFilteredImage: Dispatch<boolean>;
}

const MODULE_CONTEXT_INITIAL_VALUES = {
  moduleInfo: null,
  prevModuleInfo: null,
  setModuleInfo: (moduleInfo: ModuleInfo) => undefined,
  moduleImages: null,
  setModuleImages: (images: ModuleInfoImage[]) => undefined,
  areGridLinesEnabled: false,
  setAreGridLinesEnabled: (areGridLinesEnabled: boolean) => undefined,
  isFilteredImage: false,
  setIsFilteredImage: (isFilteredImage: boolean) => undefined,
};

export const ModuleContext = createContext<ModuleContextTypes>({
  ...MODULE_CONTEXT_INITIAL_VALUES,
});

function ModuleProvider({ children }: ModuleProviderProps) {
  const [moduleInfo, setModuleInfo] = useState<ModuleInfo | null>(null);
  const [moduleImages, setModuleImages] = useState<ModuleInfoImage[] | null>(
    null
  );
  const [areGridLinesEnabled, setAreGridLinesEnabled] = useState<boolean>(
    false
  );
  const [isFilteredImage, setIsFilteredImage] = useState<boolean>(false);

  const prevModuleInfoRef = useRef<ModuleInfo>();
  useEffect(() => {
    prevModuleInfoRef.current = moduleInfo;
  });
  const prevModuleInfo = prevModuleInfoRef.current;

  const providerValue = {
    moduleInfo,
    prevModuleInfo,
    setModuleInfo,
    moduleImages,
    setModuleImages,
    areGridLinesEnabled,
    setAreGridLinesEnabled,
    isFilteredImage,
    setIsFilteredImage,
  };

  return (
    <ModuleContext.Provider value={providerValue}>
      {children}
    </ModuleContext.Provider>
  );
}

export default ModuleProvider;
